import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function NotFound() {

  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        {/* Big 404 */}
        <Typography
        sx={{
            fontSize: { xs: "96px", md: "140px" },
            fontWeight: 800,
            color: "#3f3f3f",
            lineHeight: 1,
            textShadow: "0 12px 25px rgba(0,0,0,0.15)", // 👈 shadow
        }}
        >
        {t("404")}
        </Typography>

        {/* Subtitle */}
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: 500,
            color: "#6b7280",
            letterSpacing: "0.5px",
            mt: 1,
          }}
        >
          {t("PAGE NOT FOUND")}
        </Typography>

        {/* Optional internal key (as in the image) */}
        <Typography
          sx={{
            fontSize: "12px",
            color: "#9ca3af",
            mt: 0.5,
          }}
        >
          {t("404_page_message")}
        </Typography>

        <Button
        onClick={() => navigate("/")}
        sx={{
            mt: 3,
            px: 4,
            py: 1.5,
            fontWeight: 700,
            fontSize: "13px",
            backgroundColor: "#6c7280",
            color: "#ffffffff",
            boxShadow: "0 10px 25px rgba(162, 162, 162, 0.35)",
        }}
        >
        {t("العودة إلى الصفحة الرئيسية")}
        </Button>
      </Box>
    </Box>
  );
}

export default NotFound;
